import { useFormContext, useWatch } from 'react-hook-form';
import { useBootstrapState } from '../../../../../bootstrap/bootstrap-provider';
import { BoloPanelFormType } from '@mark43/cad-api';
import { BoloPanelTab } from '../bolo-panel-tab';
import { TabBody } from '../../../../../panels/entity-panels/tabs/tab-body';
import { TabSubtitle } from '../../../../../panels/entity-panels/tabs/tab-subtitle';
import { FormBody } from '../../../../../forms/integrated-form-components/form-body';
import { BoloPanelFormVehiclesFields } from '../../../form/bolo-panel-form-vehicles-fields';

export const BoloPanelVehiclesTab = () => {
    const boloForm = useFormContext<BoloPanelFormType>();
    const eventPanelOptions = useBootstrapState().eventPanelOptions;

    const vehicles = useWatch({
        control: boloForm.control,
        name: 'involvedVehicles',
    });

    return (
        <BoloPanelTab title="Vehicles">
            <TabBody>
                <TabSubtitle>Vehicles ({vehicles.length})</TabSubtitle>
                <FormBody>
                    <BoloPanelFormVehiclesFields
                        isNewBolo={false}
                        displayAsCards={true}
                        form={boloForm}
                        eventPanelOptions={eventPanelOptions!}
                        hideDexFields={true}
                        allowMembersControl={true}
                        noMembersText="No Vehicles"
                    />
                </FormBody>
            </TabBody>
        </BoloPanelTab>
    );
};
